import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { TagType, ContractType, CreateContractType, UpdateContractType } from 'Pages/partner'
import { RequestParams, ResponseCatalog } from 'Models'
import { serialize } from 'object-to-formdata'

export const contractsApi = {
	getTags: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<TagType>>(urls.partner.contract.tags, {
			params,
		})
		return res.data
	},
	createOne: async (partner_id: string, document_type: string, data: CreateContractType) => {
		const res = await axiosDS().post<ContractType>(
			urls.partner.contract.create
				.replace(':partner_id', partner_id)
				.replace(':document_type', document_type),
			serialize({ data }, { allowEmptyArrays: true })
		)
		return res.data
	},
	updateOne: async (partner_id: string, id: string, data: UpdateContractType) => {
		const res = await axiosDS().patch<ContractType>(
			urls.partner.contract.update.replace(':partner_id', partner_id).replace(':id', id),
			{ data }
		)
		return res.data
	},
	deleteOne: async (partner_id: string, id: string) => {
		const res = await axiosDS().delete(
			urls.partner.contract.delete.replace(':partner_id', partner_id).replace(':id', id)
		)
		return res.data
	},
}
